<template>
	<v-card 
		class="text-center mx-auto"
		:max-width="maxWidth"
		:width="width"
		flat
	>
		<v-card-item>
			<v-card-title :class="titleClass">
				{{ title }}
			</v-card-title>
			<v-card-subtitle :class="subtitleClass">
				{{ subtitle }}
			</v-card-subtitle>
		</v-card-item>

		<v-card-text>
			{{ text }}
		</v-card-text>

		<v-card-text v-if="errors.length > 0">
			<div><strong>Виявлено критичні помилки</strong></div>
			<v-icon color="error" icon="mdi-alert-circle" size="100"></v-icon>

			<v-banner v-for="(item, i) in errors" :key="i"
				color="error"
				lines="two"
				stacked
				density="compact"
			>
				<v-banner-text class="text-left">
					 <div><strong>{{ item.name }}</strong></div>
					 <div v-for="(error, i) in item.errors" :key="i">
						{{ error }}
					 </div>
				</v-banner-text>
				<template v-slot:actions>
					<v-btn @click="setStep(item.code)">Виправити</v-btn>
				</template>
			</v-banner>
		</v-card-text>
		<v-card-text v-else>
			<div><strong>Перевірка успішна</strong></div>
			<v-icon color="success" icon="mdi-check-circle-outline" size="100"></v-icon>

			<div class="my-6">Дані, надані мною, коректні!</div>
			<v-btn width="50%" @click="onOk">Підтверджую</v-btn>
		</v-card-text>

		<v-form ref="form"></v-form>
	</v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import mixin from './mixin/main'

export default {
	mixins: [mixin],
	
	computed: {
		errors() {
			//console.log('errors', 'errors', this.windows.filter((element) => element.errors.length > 0))
			const elements = this.claim?.dialog?.elements ? this.claim.dialog.elements : [];

			return elements.filter((element) => element.errors?.length > 0)
		},
	},

	methods: {
		onOk() {
			//console.log(that.$options.name, 'onOk', 'claim', claim)

			var that = this
			this.loading = true
			return axios.post(`/claim/completion`, this.claim).then(response => {
				//console.log(that.$options.name, 'onOk','response.data', response.data)
				
				that.setClaim(response.data)
				that.setStep(0)
			}, error => {
				//console.log('error', error)
				this.showMessage(error)
			}).finally(() => {
				this.loading = false
			});
		},
	},
}
</script>
